"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Property = function Property(props) {
  return _react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M6 6.5C5.86739 6.5 5.74021 6.44732 5.64645 6.35355C5.55268 6.25979 5.5 6.13261 5.5 6C5.5 5.86739 5.55268 5.74021 5.64645 5.64645C5.74021 5.55268 5.86739 5.5 6 5.5H8C8.13261 5.5 8.25979 5.55268 8.35355 5.64645C8.44732 5.74021 8.5 5.86739 8.5 6C8.5 6.13261 8.44732 6.25979 8.35355 6.35355C8.25979 6.44732 8.13261 6.5 8 6.5H6Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M6 8.5C5.86739 8.5 5.74021 8.44732 5.64645 8.35355C5.55268 8.25979 5.5 8.13261 5.5 8V6C5.5 5.86739 5.55268 5.74021 5.64645 5.64645C5.74021 5.55268 5.86739 5.5 6 5.5C6.13261 5.5 6.25979 5.55268 6.35355 5.64645C6.44732 5.74021 6.5 5.86739 6.5 6V8C6.5 8.13261 6.44732 8.25979 6.35355 8.35355C6.25979 8.44732 6.13261 8.5 6 8.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M6 18.5C5.86739 18.5 5.74021 18.4473 5.64645 18.3536C5.55268 18.2598 5.5 18.1326 5.5 18C5.5 17.8674 5.55268 17.7402 5.64645 17.6464C5.74021 17.5527 5.86739 17.5 6 17.5H8C8.13261 17.5 8.25979 17.5527 8.35355 17.6464C8.44732 17.7402 8.5 17.8674 8.5 18C8.5 18.1326 8.44732 18.2598 8.35355 18.3536C8.25979 18.4473 8.13261 18.5 8 18.5H6Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M6 18.5C5.86739 18.5 5.74021 18.4473 5.64645 18.3536C5.55268 18.2598 5.5 18.1326 5.5 18V16C5.5 15.8674 5.55268 15.7402 5.64645 15.6464C5.74021 15.5527 5.86739 15.5 6 15.5C6.13261 15.5 6.25979 15.5527 6.35355 15.6464C6.44732 15.7402 6.5 15.8674 6.5 16V18C6.5 18.1326 6.44732 18.2598 6.35355 18.3536C6.25979 18.4473 6.13261 18.5 6 18.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 6.5H16C15.8674 6.5 15.7402 6.44732 15.6464 6.35355C15.5527 6.25979 15.5 6.13261 15.5 6C15.5 5.86739 15.5527 5.74021 15.6464 5.64645C15.7402 5.55268 15.8674 5.5 16 5.5H18C18.1326 5.5 18.2598 5.55268 18.3536 5.64645C18.4473 5.74021 18.5 5.86739 18.5 6C18.5 6.13261 18.4473 6.25979 18.3536 6.35355C18.2598 6.44732 18.1326 6.5 18 6.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 8.5C17.8674 8.5 17.7402 8.44732 17.6464 8.35355C17.5527 8.25979 17.5 8.13261 17.5 8V6C17.5 5.86739 17.5527 5.74021 17.6464 5.64645C17.7402 5.55268 17.8674 5.5 18 5.5C18.1326 5.5 18.2598 5.55268 18.3536 5.64645C18.4473 5.74021 18.5 5.86739 18.5 6V8C18.5 8.13261 18.4473 8.25979 18.3536 8.35355C18.2598 8.44732 18.1326 8.5 18 8.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 18.5H16C15.8674 18.5 15.7402 18.4473 15.6464 18.3536C15.5527 18.2598 15.5 18.1326 15.5 18C15.5 17.8674 15.5527 17.7402 15.6464 17.6464C15.7402 17.5527 15.8674 17.5 16 17.5H18C18.1326 17.5 18.2598 17.5527 18.3536 17.6464C18.4473 17.7402 18.5 17.8674 18.5 18C18.5 18.1326 18.4473 18.2598 18.3536 18.3536C18.2598 18.4473 18.1326 18.5 18 18.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 18.5C17.8674 18.5 17.7402 18.4473 17.6464 18.3536C17.5527 18.2598 17.5 18.1326 17.5 18V16C17.5 15.8674 17.5527 15.7402 17.6464 15.6464C17.7402 15.5527 17.8674 15.5 18 15.5C18.1326 15.5 18.2598 15.5527 18.3536 15.6464C18.4473 15.7402 18.5 15.8674 18.5 16V18C18.5 18.1326 18.4473 18.2598 18.3536 18.3536C18.2598 18.4473 18.1326 18.5 18 18.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M12 6L8 10V16H11V12H13V16H16V10L12 6Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M23 12H24C24.0023 10.2968 23.6408 8.61271 22.9395 7.06055L20 10V16H23V12Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M1.06053 7.06055C0.35924 8.61271 -0.00234004 10.2968 5.61787e-06 12H1.00001V16H4.00001V10L1.06053 7.06055Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.foregroundColor
  }))));
};

Property.defaultProps = {
  altText: "Property",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Property.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Property;
exports.default = _default;